import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'fk-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    imports: [IconComponent, CommonModule],
})
export class TagComponent {
  @Input()
  public selected: boolean = false;

  @Input()
  public removable: boolean = false;

  @Input()
  public disable: boolean = false;

  @Output()
  public remove: EventEmitter<void> = new EventEmitter();

  public removeEvent(event: Event): void {
    this.remove.emit();

    event.stopPropagation();
  }

  protected getPaddingCls(): string {
    let paddingClasses = 'fk-pv1 fk-pr3 ';
    paddingClasses += this.removable ? 'fk-pl2' : 'fk-pl3';
    return paddingClasses;
  }
}
